import { render, staticRenderFns } from "./LandingIm.vue?vue&type=template&id=d7052c28&scoped=true&"
import script from "./LandingIm.vue?vue&type=script&lang=js&"
export * from "./LandingIm.vue?vue&type=script&lang=js&"
import style0 from "./LandingIm.vue?vue&type=style&index=0&id=d7052c28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7052c28",
  null
  
)

export default component.exports